import type { PortaDosAutos } from '../types/baixarProcesso.types';

/**
 * Raiz das rotas dos autos em PDF. A equipe interna fala com o espelho admin (`/admin/arbitral`),
 * que alcança processo de qualquer escritório da empresa; o escritório, com a rota dele, que
 * exige a permissão de consulta arbitral no workspace.
 *
 * @example rotaBaseDosAutos('secretaria', 'proc-1') // '/admin/arbitral/processos/proc-1/autos-pdf'
 */
export function rotaBaseDosAutos(porta: PortaDosAutos, processoId: string): string {
  const prefixo = porta === 'secretaria' ? '/admin/arbitral' : '/arbitral';
  return `${prefixo}/processos/${encodeURIComponent(processoId)}/autos-pdf`;
}
